<template>
    <v-app-bar
        dense
        app
    >
        <v-container
            class="pa-0 d-flex"
            fluid
        >
            <v-app-bar-nav-icon
                @click="$emit('update:drawer', !drawer)"
            ></v-app-bar-nav-icon>

            <v-spacer></v-spacer>

            <s-profile-menu></s-profile-menu>
        </v-container>
    </v-app-bar>
</template>

<script>
import {default as SProfileMenu} from './NavBar/ProfileMenu';

export default {
    components: {
        SProfileMenu,
    },
    props: {
        drawer: {
            type: Boolean,
            required: true,
        },
    },
    computed: {
        user() {
            return this.getUser()
        }
    },
};
</script>

<style scoped lang="scss">
header {
    background-color: var(--v-app-bar-base) !important;
}

.v-app-bar__nav-icon {
    color: var(--v-app-bar-text-base) !important;
}
</style>
